import { IconSearch } from '@tabler/icons-react'

import { Container } from './Container'

type Props = {
	isDesktop: boolean
	onClick: () => void
}

export const ButtonSearch = ({ isDesktop, onClick }: Props) => (
	<Container isDesktop={isDesktop} onClick={onClick}>
		<IconSearch size={16} />
		{isDesktop ? 'Search the docs' : 'Search'}
	</Container>
)
